import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { getSelectedProductLot } from '../../../selectors/Bundle/BundleProductOptionsSelector';
import ProductConstants from '../../../helpers/ProductConstants';
import * as styles from './BundleChildDetails.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
function descriptionDetails(productDesc) {
    const requiredLength = productDesc.length;
    const productDescArr =
        requiredLength && requiredLength > 3 ? productDesc.slice(0, 3) : productDesc;

    let productDescription = null;

    const renderItem = productDescArr.map(({ description }, index) => (
        <li
            className={cx('descriptionItem')}
            key={description}
            data-automation-id={`list-item-${index}`}
        >
            {description}
        </li>
    ));

    if (productDescArr && productDescArr.length > 1) {
        productDescription = (
            <ul
                className={cx('descriptionList')}
                key={1}
                data-automation-id="test-automation-product-description"
            >
                {renderItem}
            </ul>
        );
    } else if (productDescArr && productDescArr.length === 0) {
        productDescription = (
            <div className={dt(['font-normal', 'text-sm', 'text-black', 'leading-6', 'py-2'])}>
                {ProductConstants.DESCRIPTION_UNAVAILABLE}
            </div>
        );
    }

    return productDescription;
}

/* istanbul ignore next */
const BundleChildDescription = ({ index }) => {
    const selectedLot = useSelector((state) => getSelectedProductLot(false)(state, index));
    const productDesc = get(selectedLot, '[0].bulletedAttributes', []);
    const requiredProductDesc = productDesc ? descriptionDetails(productDesc) : null;

    return (
        <section>
            {requiredProductDesc ? (
                <div>
                    <h4 className={dt(['lg:text-large', 'text-black', 'font-semibold'])}>
                        Product Description
                    </h4>
                    {requiredProductDesc}
                </div>
            ) : null}
        </section>
    );
};

BundleChildDescription.propTypes = {
    index: PropTypes.number,
};

BundleChildDescription.defaultProps = {
    index: 0,
};

export default BundleChildDescription;
